import { ChevronDown, Check } from "lucide-react";
import { useHeaderProfileBlock } from "@/hooks/useHeaderProfileBlock";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import AvatarProfile from "./AvatarProfile";
import { setCookie } from "@/utils/cookies";
import { useQueryClient } from "@tanstack/react-query";
import { HeaderProfileBlockSkeleton } from "./HeaderProfileBlockSkeleton";
import { invalidateClientScopedQueries } from "@/utils/queryInvalidation";

const HeaderProfileBlock = () => {
  const { userNames, selectedUserId, isLoading, closeAccordionToggle } = useHeaderProfileBlock();
  const queryClient = useQueryClient();

  if (isLoading) {
    return <HeaderProfileBlockSkeleton />;
  }

  const selectedFirstName = userNames.find((u) => u.id === selectedUserId)?.firstName ?? "";

  const handleSelect = async (userId: string) => {
    const userInfo = userNames.find((u) => u.id === userId);
    if (!userInfo) return;
    closeAccordionToggle();
    setCookie("user_token", userInfo.token);
    await invalidateClientScopedQueries(queryClient);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="flex w-auto items-center gap-2 rounded-md px-1 text-base outline-none focus:outline-none focus:ring-0 md:max-w-[280px] md:border md:px-3 md:py-1.5 md:shadow-sm"
        >
          <AvatarProfile className="!hidden md:!flex" />
          <span className="truncate">{selectedFirstName}</span>
          <ChevronDown className="h-4 w-4 shrink-0 opacity-50" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" collisionPadding={8} className="max-w-[calc(100vw-1rem)]">
        {userNames.map((item) => (
          <DropdownMenuItem
            key={item.id}
            onSelect={() => handleSelect(item.id)}
            className="cursor-pointer text-base"
          >
            <span className="flex-1">{item.fullName}</span>
            {item.id === selectedUserId && <Check className="ml-2 h-4 w-4" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default HeaderProfileBlock;
